import React from "react";
import { jsx } from "slate-hyperscript";
import {
    InlineHandler, StyleType,
} from "./base";

InlineHandler.register(StyleType.ITALIC, {
    nodeTypes: ["EM", "I"],
    toBlock: child => <em>{child}</em>,
    serialize: child => `<em>${child}</em>`,
    deserialize: children => jsx("text", { ...children, [StyleType.ITALIC]: Object.create(null) }),
});
